import { httpRequest } from '@shared/api/httpRequests'

export const DATAGRID_API = {
  CREATE_PRESET: '/Datagrid/presets',
  DELETE_PRESET: '/Datagrid/presets/:presetId',
  DELETE_FAVORITE_PRESET: '/user/preferences/favoritePreset/',
  GET_PRESETS: '/Datagrid/presets/:scope',
  GET_FAVORITE_PRESET: '/user/preferences/',
  UPDATE_PRESET: '/Datagrid/presets',
  SET_FAVORITE_PRESET: '/user/preferences/',
  START_BULK_ACTION: '/activity-submit/api/v1/wfi/:actionName',
}

export const createPreset = async (preset) => {
  const response = await httpRequest({
    method: 'POST',
    url: DATAGRID_API.CREATE_PRESET,
    data: preset,
  })
  return response
}

export const deleteFavoritePreset = async () => {
  return await httpRequest({
    method: 'DELETE',
    url: DATAGRID_API.DELETE_FAVORITE_PRESET,
  })
}

export const deletePreset = async (presetId) => {
  return await httpRequest({
    method: 'DELETE',
    url: DATAGRID_API.DELETE_PRESET.replace(':presetId', presetId),
  })
}

export const getFavoritePresets = async () => {
  const response = await httpRequest({
    method: 'GET',
    url: DATAGRID_API.GET_FAVORITE_PRESET,
  })

  return response
}

export const getPresets = async (scope = 'config.ic-applications-presets') => {
  const response = await httpRequest({
    method: 'GET',
    url: DATAGRID_API.GET_PRESETS.replace(':scope', scope),
  })

  return response
}

export const setFavoritePreset = async (presetId) => {
  const payload = {
    preferenceKey: 'favoritePreset',
    preferenceValue: presetId,
  }

  const response = await httpRequest({
    method: 'POST',
    url: DATAGRID_API.SET_FAVORITE_PRESET,
    data: payload,
  })

  return response
}

export const updatePreset = async (preset) => {
  return await httpRequest({
    method: 'PATCH',
    url: DATAGRID_API.UPDATE_PRESET,
    data: preset,
  })
}

export const getBulkActionUrl = (action) =>
  action.url ?? DATAGRID_API.START_BULK_ACTION.replace(':actionName', action.name)

export const startBulkAction = async (action, appIds) => {
  return await httpRequest({
    method: 'POST',
    url: getBulkActionUrl(action),
    data: { appIds },
  })
}
